export default {
    path: '/RealName',
    name: 'RealName',
    component: () => import(/* webpackChunkName: "login" */ "@/pages/index/views/RealName"),
    meta: {
        title: '实名认证'
    },
}
